import * as Window from './Window';

const getQueryStringFromHash = (): string => {
  const hash = Window.getWindow().location.hash;
  const urlArray = hash && hash.split('?');
  return urlArray && urlArray.length > 1 ? urlArray[1] : '';
};

/**
 * @deprecated we should use the location object passed in by the router.
 */
const getHashOrQueryParam = (paramName: string): string => {
  return (
    new URLSearchParams(getQueryStringFromHash()).get(paramName) ||
    getUrlSearchParams().get(paramName) ||
    ''
  );
};

const getUrlSearchParams = () => {
  return new URLSearchParams(Window.getWindow().location.search);
};

const getWindowLocationWithoutHashOrQuery = () => {
  return (
    Window.getWindow().location.origin + Window.getWindow().location.pathname.replace(/\/$/, '')
  );
};

export { getQueryStringFromHash, getHashOrQueryParam, getWindowLocationWithoutHashOrQuery };
